export default __webpack_public_path__ + "static/bg-wires--mobile-24df4427f153396d47fa3be7fbce7eed.webp";